import React from 'react';
import PropTypes from 'prop-types';
import take from 'lodash/take';
import { Flex, Box, Icon, Text } from '@qga/roo-ui/components';
import { INCLUSIONS_PREVIEW_AMOUNT } from 'config/constants';

const Inclusions = ({ inclusions, ...rest }) => {
  if (!inclusions || inclusions.length === 0) return null;

  const maxDisplayInclusions = take(inclusions, INCLUSIONS_PREVIEW_AMOUNT);
  const remaining = inclusions.length - INCLUSIONS_PREVIEW_AMOUNT;

  return (
    <Flex data-testid="search-inclusions" flexDirection="column" alignItems="flex-start" {...rest}>
      {maxDisplayInclusions.map((inclusion, index) => (
        <Box pb={2} key={index} data-testid="inclusion" title={inclusion.description}>
          <Flex justifyContent="start" alignItems="center" borderRadius="rounded">
            <Icon name={inclusion.icon} color="ui.iconBadge" size={20} mr={2} role="img" />
            <Text data-testid="inclusion-name">{inclusion.name}</Text>
          </Flex>
        </Box>
      ))}
      {remaining > 0 && (
        <Text data-testid="more-inclusions">
          + {remaining} more {remaining === 1 ? 'inclusion' : 'inclusions'}
        </Text>
      )}
    </Flex>
  );
};

Inclusions.propTypes = {
  inclusions: PropTypes.array.isRequired,
};

export default Inclusions;
